/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import ExternalLink from '../ExternalLink'

import type { DocLinkProps } from './types'
import type { FunctionComponent } from 'react'

const ServerlessDocLink: FunctionComponent<DocLinkProps> = ({
  href,
  hash,
  showExternalLinkIcon,
  children,
  'aria-label': ariaLabel,
}) => (
  <ExternalLink
    showExternalLinkIcon={showExternalLinkIcon}
    href={getServerlessDocLinkUrl({ href, hash })}
    className='docLink'
    aria-label={ariaLabel}
  >
    {children}
  </ExternalLink>
)

function getServerlessDocLinkUrl({ href, hash }: Pick<DocLinkProps, 'href' | 'hash'>) {
  const baseUrl = `https://docs.elastic.co/serverless`

  if (hash != null) {
    return `${baseUrl}/${href}#${hash}`
  }

  return `${baseUrl}/${href}`
}

export default ServerlessDocLink
